
import dust from "dustjs-linkedin";


(function(){dust.register("survey",body_0);function body_0(chk,ctx){return chk.write("<div class=\"modal-container survey\"><div class=\"modal survey\"><iframe class=\"typeform\" src=\"").reference(ctx.get(["surveyUrl"], false),ctx,"h").write("\"></iframe></div></div>");}return body_0;})();

export default 0;
